import { render, staticRenderFns } from "./resetPassModel.vue?vue&type=template&id=35cc588e&scoped=true"
import script from "./resetPassModel.vue?vue&type=script&lang=js"
export * from "./resetPassModel.vue?vue&type=script&lang=js"
import style0 from "./resetPassModel.vue?vue&type=style&index=0&id=35cc588e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc588e",
  null
  
)

export default component.exports